// New Dawn Counselling logo mark (pines + rising sun + hill), traced from the
// brand artwork. Two flat brand colours; sized via className on the caller.
export default function LogoMark({ className }: { className?: string }) {
  return (
    <svg
      width="719"
      height="516"
      viewBox="0 0 719 516"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
    >
    <g transform="translate(0.000000,516.000000) scale(0.083333,-0.083333)"
    fill="#3f8e3f" stroke="none">
    <path d="M2324 5625 c-10 -15 -30 -84 -44 -153 -84 -392 -275 -754 -537 -1019
    -74 -75 -132 -140 -128 -144 22 -23 220 -13 334 16 66 17 121 29 124 26 6 -6
    -143 -225 -235 -343 -160 -204 -293 -345 -518 -548 -16 -15 40 -28 116 -28
    103 0 224 24 360 71 55 20 100 30 100 24 0 -15 -171 -267 -232 -341 -181 -221
    -226 -274 -305 -356 -98 -100 -101 -110 -43 -178 25 -30 39 -36 84 -36 73 0
    243 43 337 85 43 19 82 35 89 35 16 0 -77 -119 -177 -226 -82 -89 -82 -89 -57
    -132 58 -103 39 -150 -85 -207 -40 -19 -66 -34 -58 -34 8 -1 15 -9 15 -19 0
    -30 91 -119 189 -187 103 -69 123 -89 123 -121 0 -33 -81 -116 -153 -157 -34
    -19 -63 -40 -63 -46 0 -29 182 -217 248 -255 19 -11 186 46 292 101 111 57
    120 58 114 8 -3 -21 -11 -201 -18 -399 -8 -198 -17 -387 -22 -420 -8 -60 -8
    -60 -86 -69 -137 -16 -539 -82 -755 -124 -115 -22 -211 -39 -212 -38 -6 7 -31
    443 -26 448 4 4 28 -7 53 -24 116 -76 340 -140 502 -143 102 -2 186 16 186 40
    0 5 -29 31 -64 59 -88 67 -276 263 -359 373 -37 49 -66 91 -65 92 1 1 32 -8
    68 -20 76 -26 295 -72 340 -72 77 0 71 11 -104 184 -160 159 -410 464 -380
    464 7 0 33 -8 57 -19 91 -38 315 -37 315 2 0 9 -5 17 -10 17 -29 0 -245 225
    -345 359 -61 83 -110 152 -108 154 3 3 25 -4 51 -15 61 -26 219 -38 255 -19
    38 21 28 41 -41 87 -33 22 -96 86 -141 141 -125 157 -199 320 -299 661 -12 41
    -22 54 -40 54 -26 0 -30 -10 -79 -192 -56 -212 -212 -481 -368 -640 -49 -49
    -86 -95 -84 -103 7 -20 171 -23 238 -3 33 10 59 13 59 9 0 -29 -180 -255 -296
    -372 -75 -75 -136 -141 -136 -146 0 -31 178 -31 297 0 48 12 87 21 87 18 0
    -33 -310 -389 -434 -498 -55 -48 -102 -94 -104 -103 -10 -42 208 -35 346 12
    50 16 92 28 94 26 16 -16 -183 -251 -324 -383 -121 -113 -121 -113 -84 -132
    97 -50 437 6 630 103 26 13 48 22 50 20 4 -5 -28 -480 -33 -484 -2 -2 -127
    -34 -279 -72 -152 -38 -306 -80 -342 -94 -147 -55 -235 -54 4021 -55 3704 -1
    4139 1 4139 22 0 10 -327 100 -522 144 -844 189 -1682 310 -2574 373 -291 21
    -1304 29 -1638 13 -395 -18 -693 -39 -961 -68 -61 -6 -61 -6 -70 255 -5 144
    -13 343 -19 442 -5 99 -8 182 -6 184 2 2 32 -15 68 -38 247 -158 655 -295 839
    -282 118 9 116 18 -30 163 -165 163 -448 490 -436 502 2 2 51 -15 109 -39 228
    -91 555 -147 659 -113 84 28 81 38 -54 146 -240 193 -439 395 -629 641 -53 68
    -160 226 -157 229 2 2 42 -15 89 -38 148 -70 282 -104 419 -106 123 -1 167 12
    154 46 -3 8 -53 53 -111 100 -192 155 -377 368 -577 662 -60 89 -107 163 -105
    165 3 3 31 -7 63 -21 155 -66 476 -116 507 -79 14 16 -4 38 -136 166 -153 148
    -311 328 -446 508 -97 129 -165 233 -158 240 4 4 27 -2 52 -13 102 -42 357
    -70 400 -43 11 8 -20 46 -116 141 -249 248 -437 595 -548 1012 -52 198 -70
    225 -106 166z"/>
    </g>
    <g transform="translate(0.000000,516.000000) scale(0.083333,-0.083333)"
    fill="#f6be1c" stroke="none">
    <path d="M4265 6020 c-35 -30 -35 -30 -38 -1042 -2 -557 -1 -1030 3 -1052 16
    -85 109 -117 169 -57 29 30 29 30 29 1068 0 1038 0 1038 -27 1068 -40 46 -93
    52 -136 15z"/>
    <path d="M5804 5448 c-16 -13 -37 -45 -45 -69 -7 -25 -29 -85 -48 -135 -46
    -123 -359 -990 -473 -1311 -91 -254 -92 -261 -73 -291 39 -60 134 -67 168 -14
    10 14 58 139 107 278 160 446 404 1123 465 1291 74 204 75 224 10 257 -46 24
    -74 23 -111 -6z"/>
    <path d="M7048 4551 c-37 -20 -99 -87 -550 -586 -399 -440 -602 -671 -616
    -697 -17 -33 -18 -82 -2 -113 18 -32 78 -61 113 -52 17 4 109 98 232 237 353
    399 582 658 681 771 53 59 141 158 195 218 114 128 124 160 62 212 -43 37 -64
    38 -115 10z"/>
    <path d="M7680 3239 c-109 -54 -241 -118 -294 -143 -53 -25 -231 -112 -396
    -192 -165 -81 -372 -181 -459 -223 -128 -61 -162 -83 -172 -109 -27 -71 17
    -136 93 -136 25 0 142 51 330 142 161 78 324 157 364 176 220 102 820 408 843
    429 61 56 14 153 -74 153 -23 0 -115 -38 -235 -97z"/>
    <path d="M4038 3305 c-196 -36 -368 -104 -531 -208 -146 -93 -147 -76 18 -238
    187 -184 214 -242 152 -324 -53 -69 -135 -89 -304 -75 -63 6 -117 8 -120 5
    -15 -15 299 -332 473 -476 168 -139 210 -189 210 -253 0 -147 -257 -209 -555
    -134 -53 14 -38 -7 66 -90 242 -192 289 -260 242 -345 -13 -24 -42 -53 -65
    -65 -114 -61 -509 15 -809 156 l-103 48 0 -283 0 -282 87 7 c48 4 187 15 309
    25 851 70 1925 56 2784 -36 96 -10 185 -20 198 -21 28 -2 66 97 103 274 219
    1048 -417 2044 -1465 2294 -162 39 -534 50 -690 21z"/>
    <path d="M6708 1792 c-85 -32 -99 -139 -23 -178 52 -27 1687 -27 1739 0 66 34
    80 103 29 151 -31 29 -31 29 -879 31 -466 1 -856 -1 -866 -4z"/>
    </g>
    </svg>
  );
}
